import { render, staticRenderFns } from "./CategoriasForm.vue?vue&type=template&id=00b57981&"
import script from "./CategoriasForm.vue?vue&type=script&lang=js&"
export * from "./CategoriasForm.vue?vue&type=script&lang=js&"
import style0 from "./CategoriasForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports